import { CodeDescriptionModel } from './code-description.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class RegistrationSummaryModel {
  // reason for registration reason
  reasons: CodeDescriptionModel[] = [];
  // description for other reason if selected other for registration reason.
  otherReasonText: string = null;
  // additional description for selected regulatoryagreement reason.
  regulatoryAgreementText: string = null;
  // hpd rent amount.
  hpdRentAmount: number = null;
  // STRING: bcz of Appending the I or A or D based on incidentTypeCode.
  registrationYear: number = null;

  registrationDate: Date = null;
  nonEvictionDate: Date = null;
  evictionDate: Date = null;
  filedDate: Date = null;

  partTimeEmployees: number = null;
  fullTimeEmployees: number = null;
  isBuildingEffected: boolean = null;
  isBuildingServicesEffected: boolean = null;

  constructor(model?: Partial<RegistrationSummaryModel>) {
    if (model && model !== undefined) {
      const def = new RegistrationSummaryModel();
      Object.keys(def).forEach((key: string) => {
        this[key] = model[key] !== null && model[key] !== undefined ?
          model[key] : def[key];
      });
    }
  }

  static asForm(fb: FormBuilder): FormGroup {
    return fb.group({
      reasons: ['', Validators.required],
      otherReasonText: [],
      regulatoryAgreementText: [],
      hpdRentAmount: [],
      registrationYear: [],
      registrationDate: [],
      nonEvictionDate: [],
      evictionDate: [],
      filedDate: [],
      partTimeEmployees: [, Validators.required],
      fullTimeEmployees: [, Validators.required],
      isBuildingEffected: [],
      isBuildingServicesEffected: []
    });
  }

  static generateForm(fb: FormBuilder, model: RegistrationSummaryModel): FormGroup {
    const form = RegistrationSummaryModel.asForm(fb);
    form.setValue(model);
    return form;
  }

  static asModel(form: FormGroup): RegistrationSummaryModel {
    const model = new RegistrationSummaryModel(form.getRawValue());
    return model;
  }
}
